import { SearchEngine } from '@/components/SearchEvents/Engine';
import { Results } from '@/components/SearchEvents/Results';

const EventsSearching = { SearchEngine, Results };

export default EventsSearching;
